import { TableContainer } from '@material-ui/core'
import styled from 'styled-components'

export const tabelaStyles = {
  TableContainer: styled(TableContainer).attrs((props: { maxheight?: string }) => props)`
    max-height: ${(props) => (props.maxheight ? props.maxheight : '55vh')};
  `
}
